import React, { useState, useEffect } from 'react';
import '../../styles/Modals.css';

const IssueDescriptionModal = ({ isOpen, onClose, onSubmit, title = 'Report Issue', placeholder = 'Describe the issue with the asset...' }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setValue('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      onSubmit(value.trim());
      setValue('');
      onClose();
    }
  };

  const handleCancel = () => {
    setValue('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', padding: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#2d3748' }}>
            {title}
          </h2>
          <button type="button" className="modal-close-btn" onClick={handleCancel} aria-label="Close">
            ×
          </button>
        </div>
        
        <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#718096' }}>
          Please describe the issue with this asset:
        </p>

        <form onSubmit={handleSubmit}>
          <textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            rows="5"
            autoFocus
            required
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #e2e8f0',
              borderRadius: '6px',
              fontSize: '14px',
              fontFamily: 'inherit',
              resize: 'vertical',
              marginBottom: '16px',
              boxSizing: 'border-box'
            }}
          />

          <div className="modal-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                background: '#e2e8f0',
                color: '#4a5568',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '14px'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!value.trim()}
              style={{
                padding: '10px 20px',
                background: !value.trim() ? '#cbd5e0' : 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: !value.trim() ? 'not-allowed' : 'pointer',
                fontWeight: 600,
                fontSize: '14px',
                opacity: !value.trim() ? 0.6 : 1
              }}
            >
              Submit Issue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IssueDescriptionModal;

